function currentUrlPrefix() {
    const pathname = window.location.pathname;
    let sitename = pathname.split("/")[1];
    if (window.cobra) {
        sitename = window.cobra.siteName;
    }
    let ret = window.location.protocol + "//" + window.location.host + "/";
    if (sitename) {
        ret = ret + sitename + "/";
    }
    return ret;
}

//# sourceMappingURL=currentUrlPrefix.js.map
